export default __webpack_public_path__ + "static/media/leftchevron.ead5fb7c.svg";